import React, { useState } from 'react';
import './verify.css';
import { baseUrlUser } from './common';

const VerifyEmail = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleVerify = async () => {
    try {
      const response = await fetch(`${baseUrlUser}users/verify/email/internal/${email}`);
      const data = await response.text();

      if (response.ok) {
        if (data.toLocaleLowerCase().includes('already')){
        setStatus('Email already verified')
        setIsSuccess(true);
        }
         else {
        setStatus('email verified successfully');
        setIsSuccess(true);
      }
      } else{
        setStatus(data || 'Failed to verify email');
        setIsSuccess(false);
      }
    } catch (error) {
      console.error('Error verifying email:', error);
      setStatus('An error occurred.');
      setIsSuccess(false);
    }
  };

  return (
    <div className="verify-page">
      <div className="verify-container">
        <h2 className="verify-title">Verify User Email</h2>
        <input
          className="verify-input"
          type="email"
          placeholder="Enter user email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button className="verify-button" onClick={handleVerify}>
          Verify Email
        </button>
        {status && (
          <p className={`verify-status ${isSuccess ? 'success' : 'error'}`}>
            {status}
          </p>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
